import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fbf965ec")

_pushScopeId("data-v-fbf965ec")
const _hoisted_1 = { class: "container settings-container" }
const _hoisted_2 = { class: "settings-header" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  class: "accordion",
  id: "accordionSettings"
}
const _hoisted_6 = { class: "card" }
const _hoisted_7 = {
  class: "card-header-settings collapsed",
  id: "headingSettingTags",
  "data-toggle": "collapse",
  "data-target": "#settingTags"
}
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "settingTags"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_11 = {
  id: "settingTags",
  class: "collapse",
  "aria-labelledby": "headingSettingTags",
  "data-parent": "#accordionSettings"
}
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "card" }
const _hoisted_14 = {
  class: "card-header-settings collapsed",
  id: "headingSettingRegions",
  "data-toggle": "collapse",
  "data-target": "#settingRegions"
}
const _hoisted_15 = { class: "mb-0" }
const _hoisted_16 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "settingRegions"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_18 = {
  id: "settingRegions",
  class: "collapse",
  "aria-labelledby": "headingSettingRegions",
  "data-parent": "#accordionSettings"
}
const _hoisted_19 = { class: "card-body card-body-locations" }
const _hoisted_20 = { class: "locations" }
const _hoisted_21 = { class: "location-item" }
const _hoisted_22 = { class: "location-item" }
const _hoisted_23 = { class: "card" }
const _hoisted_24 = {
  class: "card-header-settings collapsed",
  id: "headingSettingCurrency",
  "data-toggle": "collapse",
  "data-target": "#settingCurrency"
}
const _hoisted_25 = { class: "mb-0" }
const _hoisted_26 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "settingCurrency"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_28 = {
  id: "settingCurrency",
  class: "collapse",
  "aria-labelledby": "headingSettingCurrency",
  "data-parent": "#accordionSettings"
}
const _hoisted_29 = { class: "card-body card-body-currency" }
const _hoisted_30 = { class: "card" }
const _hoisted_31 = {
  class: "card-header-settings collapsed",
  id: "headingSettingProfiles",
  "data-toggle": "collapse",
  "data-target": "#settingProfiles"
}
const _hoisted_32 = { class: "mb-0" }
const _hoisted_33 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "settingProfiles"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_35 = {
  id: "settingProfiles",
  class: "collapse",
  "aria-labelledby": "headingSettingProfiles",
  "data-parent": "#accordionSettings"
}
const _hoisted_36 = { class: "card-body card-body-profiles" }
const _hoisted_37 = { class: "card" }
const _hoisted_38 = {
  class: "card-header-settings collapsed",
  id: "headingSettingUsers",
  "data-toggle": "collapse",
  "data-target": "#settingUsers"
}
const _hoisted_39 = { class: "mb-0" }
const _hoisted_40 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "settingUsers"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_42 = {
  id: "settingUsers",
  class: "collapse",
  "aria-labelledby": "headingSettingUsers",
  "data-parent": "#accordionSettings"
}
const _hoisted_43 = { class: "card-body card-body-users" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Tags = _resolveComponent("Tags")
  const _component_CurrencyRates = _resolveComponent("CurrencyRates")
  const _component_BoProfiles = _resolveComponent("BoProfiles")
  const _component_BoUsers = _resolveComponent("BoUsers")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('settings.title')), 1),
    (_ctx.loaded)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("h5", _hoisted_8, [
                    _createVNode("button", _hoisted_9, _toDisplayString(_ctx.$t('title.tags')), 1),
                    _hoisted_10
                  ])
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _createVNode(_component_Tags, { tags: _ctx.tags }, null, 8, ["tags"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("h5", _hoisted_15, [
                    _createVNode("button", _hoisted_16, _toDisplayString(_ctx.$t('title.regions')), 1),
                    _hoisted_17
                  ])
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _createVNode("div", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editLocation('regions')))
                        }, _toDisplayString(_ctx.$t('title.region')), 1)
                      ]),
                      _createVNode("div", _hoisted_22, [
                        _createVNode("div", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editLocation('cities')))
                        }, _toDisplayString(_ctx.$t('title.city')), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, [
                  _createVNode("h5", _hoisted_25, [
                    _createVNode("button", _hoisted_26, _toDisplayString(_ctx.$t('title.currency')), 1),
                    _hoisted_27
                  ])
                ]),
                _createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("div", null, [
                      _createVNode(_component_CurrencyRates, { items: _ctx.currencyRatesItems }, null, 8, ["items"])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, [
                  _createVNode("h5", _hoisted_32, [
                    _createVNode("button", _hoisted_33, _toDisplayString(_ctx.$t('title.profiles')), 1),
                    _hoisted_34
                  ])
                ]),
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, [
                    _createVNode(_component_BoProfiles, { items: _ctx.profiles }, null, 8, ["items"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_37, [
                _createVNode("div", _hoisted_38, [
                  _createVNode("h5", _hoisted_39, [
                    _createVNode("button", _hoisted_40, _toDisplayString(_ctx.$t('title.users')), 1),
                    _hoisted_41
                  ])
                ]),
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode("div", null, [
                      _createVNode(_component_BoUsers, { items: _ctx.users }, null, 8, ["items"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})